// extracted by mini-css-extract-plugin
export default {"savedTime":"savedTime__ZKeDv","text":"text__h71R0"};